// extracted by mini-css-extract-plugin
module.exports = {"TL":"ContentWithSplitHeader_TL__aNHVB","TR":"ContentWithSplitHeader_TR__2F7cq"};